// Copyright (c) StrangeBee 2023

// eslint-disable-next-line
export const getNestedObject = (obj: any, path: string): any => {
    if (typeof obj === 'undefined') return undefined;

    const pathArr = path.split('.').filter(Boolean);
    obj = pathArr.reduce((o, key) => (o && o[key] !== 'undefined' ? o[key] : undefined), obj);

    return obj;
};

// eslint-disable-next-line
export const convertToObject = (value: any): any => {
    if (!value) {
        return value;
    }

    if (typeof value !== 'object') {
        return JSON.parse(value);
    }
    return value;
};

// eslint-disable-next-line
export const isEmptyObject = (obj: any): boolean => Object.keys(obj).length === 0;
